import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import PopoverOnHover from './Popover/PopoverOnHover'

export class TooltipOnHover extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    tooltipContent: PropTypes.node.isRequired,
    placement: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    delayShow: PropTypes.number,
  }

  static defaultProps = {
    placement: 'bottom',
    delayShow: 400,
  }

  render() {
    const {
      children,
      disabled,
      placement,
      tooltipContent,
      delayShow,
    } = this.props

    if (disabled) {
      return children
    }

    // Allows users to pass on proper children for rendering and control their display
    const contentIsTextOnly = !React.isValidElement(tooltipContent)

    return (
      <PopoverOnHover
        id={this.props.id}
        delayShow={delayShow}
        position={placement}
        content={
          <div
            className={classNames(
              'tooltip font-size-small',
              'padding-vertical-small padding-horizontal-medium',
              'radius-normal',
              'shadow-large',
              { 'font-weight-bold': contentIsTextOnly }
            )}
          >
            {tooltipContent}
          </div>
        }
      >
        {children}
      </PopoverOnHover>
    )
  }
}

export default TooltipOnHover
